import { FolderItemORM } from 'src/types/types'
import { DNARowsComponent } from 'src/components/DNA/FlatList/Rows/types'
import { useEffect } from 'react'

// Not implemented
const DNADocumentVersionCustomDeckSearchRow: DNARowsComponent<FolderItemORM> = () => {
  useEffect(() => {
    console.error('DNADocumentVersionCustomDeckSearchRow not implemented yet')
  }, [])

  return (null)
}

export default DNADocumentVersionCustomDeckSearchRow
